import valZip from "val-zip";
import sanitizeHtml from 'sanitize-html';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const regexPatterns = {
  email: new RegExp('^[\\p{L}0-9._%\'-]+@[\\p{L}0-9.-]+\\.[\\p{L}]{2,8}$', 'u'),
  name: new RegExp('^[\\p{L}0-9 \'-.&_,]+$', 'u'),
  contactMessage: new RegExp('^[\\p{L}0-9 \'-.&_,?!~¿¡]+$', 'u'),
  zipCanada: '^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\\s[0-9][A-Z][0-9]$',
  zipUsFormat: new RegExp('^\\d{5}$'),
  domesticPhoneNumber: new RegExp('^\\d{3}-\\d{3}-\\d{4}$'),
  internationalPhoneNumber: new RegExp('^\\+((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\\W*\\d){0,13}\\d$')
}

export const maxLengths = {
  firstName: 20,
  lastName: 35,
  email: 254,
  schoolName: 100,
  streetAddress: 254,
  secondaryAddressUnit: 100,
  city: 50,
  zipCode: 12,
  fullName: 50,
  reason: 20,
  subject: 50,
  message: 500,
  numberOfStudents: 1000
}

export function sanitizeInput(value: string): string {
  return sanitizeHtml(value, {
    allowedTags: [],
    allowedAttributes: {},
  }).replaceAll('\'', '&#39;').replaceAll('\"', '&#34;').trim();
}

export function isValidUsZip(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value.length === 0 || (valZip(value, 'US') && value.match(regexPatterns.zipUsFormat))) {
          return null;
      } else {
          return { inValidZip: true };
      }
  }
}

export function isInValidator(values: any[]): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const isIn = values.includes(control.value);
    return isIn ? null : { 'isIn': { value: control.value } };
  };
}
